import {
  safePolygon,
  useDismiss,
  useFloating,
  useFocus,
  useHover,
  useInteractions,
  useRole
} from "@floating-ui/react";
import { useCallback } from "react";
const useFloatingContext = ({
  open,
  setOpen,
  disable,
  disableFocus,
  hoverable
}) => useCallback(
  (props) => {
    const floating = useFloating({
      ...props,
      open,
      onOpenChange: setOpen
    }), { getReferenceProps, getFloatingProps } = useInteractions([
      hoverable ? useHover(floating.context, {
        enabled: !disable && hoverable,
        handleClose: safePolygon({
          requireIntent: !0,
          blockPointerEvents: !0
        })
      }) : useHover(floating.context, {
        enabled: !1
      }),
      useFocus(floating.context, {
        enabled: !disable && !disableFocus,
        keyboardOnly: !0
      }),
      useRole(floating.context, { role: "dialog" }),
      useDismiss(floating.context, {
        enabled: !disable
      })
    ]);
    return {
      ...floating,
      open,
      getReferenceProps,
      getFloatingProps
    };
  },
  [open, setOpen, disable, disableFocus, hoverable]
);
export {
  useFloatingContext
};
//# sourceMappingURL=useFloatingContext.js.map
